export const autocompleteConfig: AutocompleteConfig = {
	apiKey: 'AIzaSyAQPVUx-B64ZnF83_CD43APcKCUpe04X7Q',
	autocompletionRequest: {
		componentRestrictions: {
			country: ['au'],
		},
		types: ['(regions)'],
	},
	minLengthAutocomplete: 1,
}

export const configLocation = {
	serviceUrl: '',
}

interface AutocompleteConfig {
	apiKey: string
	autocompletionRequest?: AutocompletionRequest
	minLengthAutocomplete: number
}

interface LatLng {
	lat: number
	lng: number
}

interface AutocompletionRequest {
	bounds?: [LatLng, LatLng]
	componentRestrictions?: { country: string | string[] }
	location?: LatLng
	offset?: number
	radius?: number
	types?: string[]
}
